import * as THREE from 'three';

// Airplane state
export const airplaneState = {
  enabled: true,
  x: 0,          // current X position (world space offset from center)
  targetX: 0,    // target X position
  y: 0,          // current Y offset (altitude adjustment)
  targetY: 0,    // target Y offset
  tilt: 0,       // current tilt (roll) angle
  pitch: 0,      // current pitch angle
  speed: 3,      // horizontal movement speed
  vertSpeed: 2,  // vertical movement speed
  maxOffset: 5.5,  // max left/right offset
  altitudeRange: 4.6, // max up/down range
  smoothing: 8,  // lerp smoothing factor
  height: -2.5,  // height offset from camera
  size: 0.4,     // scale of the airplane
  distance: 3.5, // distance ahead of camera
  // Chase cam world position (used when chase cam is on)
  worldPos: new THREE.Vector3(0, 1.5, 0),
  baseAltitude: 1.5, // base flying altitude in chase cam mode
  // Collision state
  isColliding: false,
  collisionShake: 0,
  collisionThreshold: -0.1, // negative = only trigger when actually below terrain
  // Flight state: 'flying', 'landed', 'crashed'
  flightState: 'flying',
  crashSpeedThreshold: 0.5, // Speed below this counts as landing attempt
  // Free roam heading/turning
  heading: 0,           // current yaw angle (radians) - 0 = facing -Z
  targetHeading: 0,     // smoothed heading target
  turnSpeed: 1.5,       // radians per second turn rate
  // Strafe
  strafeOffset: 0,      // current strafe offset (perpendicular to heading)
  targetStrafeOffset: 0, // target strafe for easing
  strafeSpeed: 1.0,     // strafe speed in units per second (slow)
  strafeEasing: 2.0,    // easing factor (lower = heavier ease-in)
  maxStrafe: 8.0,       // maximum strafe distance from center
  // Boost state
  boostCharge: 0,       // 0 to 1
  isBoosting: false,
  boostTimeRemaining: 0,
  isShiftPressed: false,
  // Smoothed FOV factor (lags behind actual speed for "pressed into seat" feel)
  smoothFovFactor: 0,
};

// Keyboard state
export const keysPressed = {
  throttleUp: false,
  throttleDown: false,
  strafeLeft: false,
  strafeRight: false
};

// Track when R key is used for respawn
export let respawnKeyUsed = false;
export function setRespawnKeyUsed(value) {
  respawnKeyUsed = value;
}

// Mouse control state for airplane direction
export const mouseControl = {
  turnRate: 0,           // continuous turn rate from mouse X (-1 to 1)
  climbRate: 0,          // continuous climb rate from mouse Y (-1 to 1)
  active: false          // whether mouse is over canvas
};

// Gyro control state for mobile devices (consolidated - no more window.__ globals)
export const gyroControl = {
  enabled: false,        // whether gyro controls are active
  active: false,         // whether we're receiving gyro data
  turnRate: 0,           // continuous turn rate from tilt (-1 to 1)
  climbRate: 0,          // continuous climb rate from tilt (-1 to 1)
  // Calibration - neutral device orientation
  calibrated: false,
  neutralBeta: 45,       // neutral pitch angle (holding phone ~45 degrees)
  neutralGamma: 0,       // neutral roll angle (level)
  // Sensitivity and dead zones
  sensitivity: 1.0,      // multiplier for gyro response
  deadZone: 3,           // degrees of dead zone around neutral
  maxAngle: 30,          // degrees for full deflection
  // Raw values for debugging
  rawBeta: 0,            // front/back tilt (-180 to 180)
  rawGamma: 0,           // left/right tilt (-90 to 90)
  // Smoothing
  smoothing: 0.15,       // lerp factor for smoothing (lower = smoother)
  smoothTurnRate: 0,
  smoothClimbRate: 0,
  // Auto-calibration state (moved from window globals)
  autoCalibrated: false,
  calibrating: false,
  needsCalibration: false  // set true to request manual recalibration
};

// Touch control state for mobile throttle/strafe zones
export const touchControl = {
  throttleUp: false,
  throttleDown: false,
  strafeLeft: false,
  strafeRight: false,
  activeTouches: new Map()  // track multiple touch points
};

// Store airplane materials for color change on collision
export let airplaneMaterials = [];
export function setAirplaneMaterials(materials) {
  airplaneMaterials = materials;
}
export function getAirplaneMaterials() {
  return airplaneMaterials;
}
